import Vue from "vue";
import VueRouter from "vue-router";

import Subject from "../components/Subject";
import Manager from "../components/Manager";
import User from "../components/User";
import Consult from "../components/Consult";
import Index from "../components/Index";
import Login from "../components/Login";

Vue.use(VueRouter);

const router = new VueRouter({
  // mode: 'history',
  routes: [
    {
      path: "/login",
      name: "login",
      component: Login,
    },
    {
      path: "",
      name: "index",
      component: Index,
      children: [
        { path: "/staff", name: "staff", component: Manager },
        { path: "/user", name: "user", component: User },
        { path: "/subject", name: "subject", component: Subject },
        { path: "/consult", name: "consult", component: Consult },
        
      ],
    },
  ],
});

export default router;
